import { lineSpacingModals } from ".//consts";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { TEXT_BUTTON_LINE_SPACING } from "./data-hooks";
import LineSpacingIcon from "./icons/toolbars-v3/LineSpacingIcon";
import LineSpacingPanelComponent from "./LineSpacingPanelComponent";
const getTextButtons = () => {
  return [
    {
      id: "LINE_SPACING",
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_LINE_SPACING,
        tooltip: "LineSpacingButton_Tooltip",
        icon: LineSpacingIcon
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      modal: {
        id: lineSpacingModals.spacingOptions,
        Component: LineSpacingPanelComponent
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
